import optimoveQueue from "./queue";
import runSafely from "./runSafely";

const callApi = (call: OptimoveCall) => {
  const status = optimoveQueue.getStatus();
  if (status === "failed") {
    return;
  }
  if (status !== "ready") {
    optimoveQueue.push(call);
    return;
  }
  const api =
    typeof window === "undefined" ? undefined : window.optimoveSDK?.API;
  if (!api) {
    return;
  }
  runSafely(call, api);
};

export default callApi;
